import React from 'react';
import Common from '../Common/common';
import CommonBooking from '../Common/common_booking';
import constClass from '../../Constants/Constants';
import moment from 'moment';
import Loading from '../Loading/Loading';

//予約内容確認画面表示
const BookingDetailView = ({ state, cancel_view, settings, shoplist, onChangeClick, checkBookingValid, customer }) => {
  const checkChange = (detail = null) => {
    var chk = false;//false:変更不可
    if (cancel_view) {
      chk = false
    } else {
      if (!detail) {
        chk = true;
      }else {
        const book_date = detail.book_date ? detail.book_date : state.booking.book_date;
        const checkChangeTimeLimit =  CommonBooking.checkChangeTime(book_date, detail.start_time, settings.BOOKING_LIMIT, settings.BOOKING_LIMIT_UNIT || 'm');
        if (!detail.book_set_id) chk = true;
        if (detail.category_id && detail.start_time && constClass.STATUS_PRE.includes(detail.booking_status || null) && checkChangeTimeLimit) chk = true;
      }
      if (state.change && !checkBookingValid(state.booking, state.booking_detail, state.bookCalList)) chk = true;//変更内容がエラー
    }
    return chk;
  }

  var viewchk1 = checkChange((state.booked ? state.booked.booking_detail : state.booking_detail)[0]);

  const renderChangeButton = (page, detail = null) => {
    if (!cancel_view && viewchk1) {
      return (
        <div className="col-2 py-1 px-1 align-self-center">
          <button
            className={`btn w-100 bg-green text-white py-1 px-1`}
            onClick={() => {
              if (detail) {
                onChangeClick({ ...state, change: true, category_id: detail.category_id, category_name: detail.category_name }, page);
              } else {
                onChangeClick({ change: true }, page);
              }
            }}>
            変更
          </button>
        </div>
      );
    }
  }
  return (
    state.booking && state.booking.book_date ? <React.Fragment>
      <div className="row mx-0 p-0 bg-white">
        <div className="col text-left m-0 p-0 border-right">
          <div className="row mx-0 px-2 pt-2 pb-1 border-bottom">
            <div className="col-5 px-0 mx-0 text-green font-weight-bold">
              会員番号
            </div>
            <div className="col px-1">
              {state.booking.card_id ? state.booking.card_id : "JA山口会員ポイントアプリ未登録です"}
            </div>
          </div>
          <div className="row mx-0 px-2 pt-2 pb-1 border-bottom">
            <div className="col-5 px-0 mx-0 text-green font-weight-bold">
              お名前
            </div>
            <div className="col px-1">
              {state.booking.customer_name}
            </div>
          </div>
          <div className="row mx-0 px-2 pt-2 pb-1 border-bottom">
            <div className="col-5 px-0 mx-0 text-green font-weight-bold">
              お名前(カナ)
            </div>
            <div className="col px-1">
              {state.booking.customer_kana}
            </div>
          </div>
          {!cancel_view && <React.Fragment>
            <div className="row mx-0 px-2 pt-2 pb-1 border-bottom">
              <div className="col-5 px-0 mx-0 text-green font-weight-bold">
                居住地(市町村)
              </div>
              <div className="col px-1">
                {state.booking.customer_address_number}<br />
                {`${state.booking.customer_address1} ${state.booking.customer_address2} ${state.booking.customer_address3}`}
              </div>
            </div>
            <div className="row mx-0 px-2 pt-2 pb-1 border-bottom">
              <div className="col-5 px-0 mx-0 text-green font-weight-bold">
                性別
              </div>
              <div className="col px-1">
                {constClass.CUSTOMER_GENDER_NAME[state.booking.customer_gender]}
              </div>
            </div>
            <div className="row mx-0 px-2 pt-2 pb-1 border-bottom">
              <div className="col-5 px-0 mx-0 text-green font-weight-bold">
                電話番号
              </div>
              <div className="col px-1">
                {state.booking.customer_phone ? state.booking.customer_phone : ""}
              </div>
            </div>
            <div className="row mx-0 px-2 pt-2 pb-1 border-bottom">
              <div className="col-5 px-0 mx-0 text-green font-weight-bold">
                携帯電話番号
              </div>
              <div className="col px-1">
                {state.booking.customer_mobilephone ? state.booking.customer_mobilephone : ""}
              </div>
            </div>
            <div className="row mx-0 px-2 pt-2 pb-1 border-bottom">
              <div className="col-5 px-0 mx-0 text-green font-weight-bold">
                生年月日
              </div>
              <div className="col px-1">
                {state.booking.birthdayy ? `${state.booking.birthdayy}/${state.booking.birthdaym}/${state.booking.birthdayd}` : ""}
              </div>
            </div>
            <div className="row mx-0 px-2 pt-2 pb-1 border-bottom">
              <div className="col-5 px-0 mx-0 text-green font-weight-bold">
                予約の目的
              </div>
              <div className="col m-0 p-0">
                <div className="row m-0 p-0">
                  <div className="col  m-0 p-0">
                    {state.talklist.find(talk => Number(talk.talk_id) === Number(state.booking.talk_id))?.talk}
                  </div>
                  <div className="col-12 m-0 p-0 pt-1"  style={{ overflowWrap: 'anywhere' }}>
                    {state.booking.talktext}
                  </div>
                </div>
              </div>
            </div>
            {/* ご希望の連絡先 */}
            <div className="row mx-0 px-2 pt-2 pb-1 border-bottom">
              <div className="col-5 px-0 mx-0 text-green font-weight-bold">
                ご希望の連絡先
              </div>
              <div className="col px-1">
                {/* 番号に合わせて表記を変える方式 */}
                {state.booking.connect_means ? constClass.CUSTOMER_PHONE_NAME[state.booking.connect_means] : ""}
              </div>
            </div>
            <div className="row mx-0 px-2 pt-2 pb-1">
              <div className="col-5 px-0 mx-0 text-green font-weight-bold">
                平日連絡可能時間
              </div>
              <div className="col px-1">
                {state.booking.customer_before_time ? `${state.booking.customer_before_time}時` : ""}
                {state.booking.customer_after_time ? `～${state.booking.customer_after_time}時` : ""}
              </div>
            </div>
          </React.Fragment>}
        </div>
        {renderChangeButton(constClass.USER)}
      </div>
      <div className="row mt-2 mx-0 p-0 bg-white">
        <div className="col text-left m-0 p-0 border-right">
          <div className="row mx-0 px-2 pt-2 pb-1 ">
            <div className="col-5 px-0 mx-0 text-green font-weight-bold">
              支所
            </div>
            <div className="col px-1">
              {state.shoplist.find(shop => Number(shop.shop_id) === Number(state.booking.shop_id))?.shop_name}
            </div>
          </div>
        </div>
        {!cancel_view && viewchk1 &&
        <div className="col-2 py-1 px-1 align-self-center">{/* 表の列数を他と統一させるための空のdiv */}</div>
        }
      </div>
      <div className="row mt-2 mx-0 p-0 bg-white">
        <div className="col text-left m-0 p-0 border-right">
          <div className="row mx-0 px-2 pt-2 pb-1 ">
            <div className="col-5 px-0 mx-0 text-green align-self-center font-weight-bold">
              予約日
            </div>
            <div className="col px-1">
              <div className='row'>
                <div className='col'>{moment(state.booking.book_date).format('YYYY/MM/DD')}</div>
              </div>
            </div>
          </div>
          {("SERVICE_COUNT_MESSAGE" in settings) &&
            <div className='row'>
              <div className='col mx-2 '><a href={Common.getExternalUrl(settings[`SERVICE_COUNT_URL`])} target="_blank" rel="noreferrer"><u>※{settings.SERVICE_COUNT_MESSAGE}</u></a></div>
            </div>
          }
        </div>
        {renderChangeButton(constClass.INPUT)}
      </div>

      {state.booking_detail.map((item, idx) => (
        <React.Fragment key={idx}>
          <div className="row mt-2 mx-0 p-0 bg-white">
            <div className="col text-left m-0 p-0 border-right">
              {item.category_id &&
                <div className="col text-left m-0 p-0">
                  {(item.errcheck) &&
                    <div className="row mx-0 p-0">
                      <div className={`col mt-1 p-1 text-left text-white ${(item.errcheck) ? "bg-warning" : ""}`}>
                        {item.errcheck}
                      </div>
                    </div>
                  }
                  <div className="row mx-0 px-2 pt-2 pb-1 ">
                    <div className="col-5 px-0 mx-0 text-green align-self-center font-weight-bold">
                      カテゴリ
                      {(constClass.STATUS_CCL.concat([constClass.STATUS.FIN])).includes(item.status) && <div>[{constClass.STATUS_NAME_USER[item.status]}]</div>}
                    </div>
                    <div className="col px-1">
                      {item.category_id &&
                        <div className="row m-0 p-0">
                          <div className="col px-0 font-weight-bold">
                            {item.category_name}
                          </div>
                        </div>
                      }
                      {(item.start_time || item.end_time || item.remarks) ?
                        <div className="row m-0 p-0">
                          {(item.start_time || item.end_time) ?
                            <div className="col px-0">
                              {CommonBooking.strTotime(item.start_time)}
                              ～{CommonBooking.strTotime(item.end_time)}
                              <div className="col px-1">
                                {item.remarks}
                              </div>
                            </div> : <div className="col px-0">{item.remarks}</div>}
                        </div>
                        : <div className="col px-0">なし</div>}
                    </div>
                  </div>
                </div>
              }
            </div>
            {renderChangeButton(constClass.INPUTBIN1, item)}
          </div>
        </React.Fragment>
      ))
      }
    </React.Fragment > : <Loading />
  );
}

export default BookingDetailView;